import { useEffect, useState, type CSSProperties } from 'react';
import { FONTS, COLORS } from '@setapart/shared';
import { verify } from '../lib/api';

interface Props {
  onDone: () => void;
}

export function VerifyCallback({ onDone }: Props) {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = new URL(window.location.href).searchParams.get('token') ?? '';
    if (!token) {
      setError('Missing token');
      return;
    }
    (async () => {
      const r = await verify(token);
      if (r.ok) onDone();
      else setError(r.error ?? 'Verify failed');
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div style={{ fontSize: 10, letterSpacing: '0.4em', textTransform: 'uppercase', fontWeight: 700, color: COLORS.muted, marginBottom: 8 }}>
        {error ? 'VERIFY FAILED' : 'SIGNING YOU IN'}
      </div>
      <h1 style={{ fontFamily: FONTS.display, fontSize: 28, color: COLORS.ink, fontStyle: 'italic', fontWeight: 500, margin: 0 }}>
        {error ? 'That link didn\'t work.' : 'One moment…'}
      </h1>
      {error && <div style={errStyle}>{error}</div>}
    </div>
  );
}

const errStyle: CSSProperties = {
  color: COLORS.accent,
  fontSize: 12,
  marginTop: 12,
};
